exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".copyTextInput{position:relative}.copyTextInput .form-control{background-color:#f6f6f6;padding-right:2.6em}.copyTextInput .btn{background-color:#f6f6f6;position:absolute;top:0;right:0;border-bottom-left-radius:0;border-top-left-radius:0;padding:5px 8px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/utility/copy_text_input.scss
// module id = 1465
// module chunks = 0